module.exports = __webpack_public_path__ + "static/media/login-back-origin.e4a560c8.jpg";